export enum StationPlugType {
  Unkown = 0,
  Type2 = 1,
  Schuko = 2,
  Swiss = 3,
  Uk = 4,
  CCS = 5,
  CHAdeMO = 6,
}
